// React
import { useState } from "react";

// React Redux
import { useSelector } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";
import { Card, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Header from "layouts/profile/components/Header";
import MDTypography from "components/MDTypography";

import FormEdit from "layouts/profile/components/EditProfile";

export default function Overview() {
  const [showEdit, setShowEdit] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  return (
    <MDBox>
      {currentUser && (
        <Header user={currentUser}>
          <MDBox mt={5} mb={3}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} lg={4}>
                <Card sx={{ height: "100%", boxShadow: true && "none" }}>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    pt={2}
                    px={2}
                  >
                    <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                      Profil d&apos;utilisateur
                    </MDTypography>
                    <Tooltip
                      title="Editer le profil"
                      placement="bottom"
                      onClick={() => setShowEdit(true)}
                    >
                      <IconButton>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" py={1} pr={2}>
                      <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Nom et Prénom: &nbsp;
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{currentUser.fullname}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" py={1} pr={2}>
                      <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Email: &nbsp;
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{currentUser.email}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" py={1} pr={2}>
                      <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        Contact: &nbsp;
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="regular" color="text">
                        &nbsp;{currentUser.tel}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} lg={8}>
                {showEdit && <FormEdit user={currentUser} finished={() => setShowEdit(false)} />}
              </Grid>
            </Grid>
          </MDBox>
        </Header>
      )}
    </MDBox>
  );
}
